angular.module('data-ng-path-item', ['utility-ng-enumeration', 'utility-ng-interface']);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/core.js